import type { Translatable } from './global'

export enum ProjectFieldType {
    id = 'id',
    status = 'status',
    string = 'string',
    number = 'number',
    boolean = 'boolean',
    date = 'date',
    currency = 'currency',
    area = 'area',
    url = 'url',
    html = 'html',
    building = 'building'
}

export enum ProjectFieldSort {
    asc = 'asc',
    desc = 'desc',
    enabled = 'enabled',
    disabled = 'disabled'
}

export interface StatusOptions {
    projectFieldId: number
    projectStatusId: number
    hide: boolean
    customRenderer: string | null
    hideRenderer: string | null
    updatedAt: string
    createdAt: string
}

export default interface Field {
    id?: number
    projectId: number
    key: string
    type: ProjectFieldType
    label: Translatable
    prefix: Translatable
    suffix: Translatable
    sortable: string
    filterable: boolean
    hiddenInList: boolean
    orderInList: number
    hiddenInDetails: boolean
    orderInDetails: number
    updatedAt: string
    createdAt: string
    isSystem: boolean
    isReadOnly: boolean
    isMandatory: boolean
    statusOptions: StatusOptions[]
}
